module.exports = __webpack_public_path__ + "img/20180815_151538_155.90d6530e.jpg";